import React, { useState, useEffect } from "react";

import api from "APP_ROOT/api";

const PartsCount = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    api.dashboard().then(({ data }) => setCount(data.parts_count));
  }, []);

  if (count === null) {
    return null;
  }

  return (
    <h5>
      PN Count: <b>{count}</b>
    </h5>
  );
};

export default PartsCount;



// WEBPACK FOOTER //
// ./app/modules/parts/components/PartsCount/PartsCount.jsx